import { Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

interface SourcingToolbarProps {
  readonly count: number;
  readonly prompt?: string | null;
  readonly onDownloadCsv?: () => void;
  readonly onSaveSearch?: () => void;
}

export function SourcingToolbar({ count, prompt, onDownloadCsv, onSaveSearch }: SourcingToolbarProps) {
  const displayText = prompt ?? `${count} companies`;
  const showActions = Boolean(prompt);

  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ mb: '0.5rem' }}>
      <Typography variant='h6'>{displayText}</Typography>

      {showActions && (
        <Stack direction='row' gap='0.75rem' alignItems='center'>
          <Tooltip title='Download CSV'>
            <IconButton size='medium' aria-label='Download CSV' onClick={onDownloadCsv}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          <Button
            variant='outlined'
            color='secondary'
            startIcon={<BookmarkBorderIcon />}
            onClick={onSaveSearch}
          >
            Save Search
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
